const getStyles = (theme) => ({

});

export default getStyles;
